import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import './pickupstatusoverlay.scss'

// Utils
import { translation } from '../../../utils/helpers'

// Components
import PickupStatusOverview from '../../components/PickupStatusOverview'

// Elements
import Overlay from '../../elements/overlay'
import Overlayheader from '../../components/OverlayHeader'

class PickupStatusOverlay extends Component {
  constructor (props) {
    super(props)

    this.state = {
    }
  }

  renderExecutionTime () {
    let executionTime = null
    let overviewPickupData = this.props.OverviewPickupData
    if (overviewPickupData !== null && overviewPickupData.ExecutionTime !== null) {
      executionTime = moment(overviewPickupData.ExecutionTime).format('HH:mm')
    }
    if (executionTime == null) return null

    return (
      <div className='executionTime'>
        {translation('16608').replace('[time]', executionTime)}
      </div>
    )
  }

  renderHeader () {
    return (
      <Overlayheader overlayId='PickupStatusOverlay' onClose={this.props.onClose}>
        <div>
          {this.renderExecutionTime()}
          <div className='heading-title'>{translation('16839')}</div>
        </div>
      </Overlayheader>
    )
  }

  render () {
    return (
      <Overlay overlayId='PickupStatusOverlay' extraClassName='pickupStatusOverlay'>
        {this.renderHeader()}
        <div className='content'>
          <PickupStatusOverview />
        </div>
      </Overlay>
    )
  }
}

function mapStateToProps (state) {
  return {
    OverviewPickupData: state.overview.OverviewPickupData
  }
}

export default connect(mapStateToProps, {

})(PickupStatusOverlay)



// WEBPACK FOOTER //
// ./src/app/shared/overlays/PickupStatusOverlay/index.js